import React from "react";
import Main from "./Main";
import Imkoniyatlar from "./Imkoniyatlar";
import "./home.css";

const Home = () => {
  return (
    <div className="home">
      <Main />
      <Imkoniyatlar />
    </div>
  );
};

export default Home;
